module.exports = __webpack_public_path__ + "static/media/joseph_serious.6f112cc9.png";